<template>
  <v-layout row justify-center>
    <v-dialog v-if="linkData" v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">visibility</v-icon>
            Page Detail
          </span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-tabs
            v-if="page"
            v-model="activeTab"
            color="grey lighten-3"
            slider-color="primary"
          >
            <v-tab ripple key="common">Common info</v-tab>
            <v-tab ripple key="words">Top 10 Words of Referral</v-tab>
            <v-tab-item key="common">
              <v-card flat>
                <table v-if="page" class="tabs-table v-datatable v-table theme--light">
                  <thead>
                    <tr>
                      <th class="text-xs-left">Property</th>
                      <th class="text-xs-left">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>URL</td>
                      <td> {{ page.url }} </td>
                    </tr>
                    <tr>
                      <td>IP</td>
                      <td> {{ page.ip }} </td>
                    </tr>
                    <tr>
                      <td>Country</td>
                      <td> {{ page.country }} </td>
                    </tr>
                    <tr>
                      <td>Completed date</td>
                      <td> {{ page.completed_at ? moment(page.completed_at).format('DD/MM/YYYY, HH:mm:ss') : '' }} </td>
                    </tr>
                    <tr>
                      <td>State</td>
                      <td> {{ page.state }} {{ page.result_type.name }} </td>
                    </tr>
                    <tr>
                      <td>Response code</td>
                      <td> {{ page.response_code }} </td>
                    </tr>
                    <tr>
                      <td>Content type</td>
                      <td> {{ page.content_type }} </td>
                    </tr>
                    <tr>
                      <td>Latency</td>
                      <td> {{ page.latency }} </td>
                    </tr>
                    <tr>
                      <td>Title</td>
                      <td> {{ page.title }} </td>
                    </tr>
                    <tr>
                      <td>Meta robots</td>
                      <td> {{ page.meta_robots }} </td>
                    </tr>
                    <tr>
                      <td>Meta description</td>
                      <td> {{ page.meta_description }} </td>
                    </tr>
                    <tr>
                      <td>Meta viewport</td>
                      <td> {{ page.meta_viewport }} </td>
                    </tr>
                    <tr>
                      <td>Meta keywords</td>
                      <td> {{ page.meta_keywords }} </td>
                    </tr>
                    <tr>
                      <td>h1</td>
                      <td> {{ page.h1 }} </td>
                    </tr>
                    <tr>
                      <td>Words count</td>
                      <td> {{ page.words_count }} </td>
                    </tr>
                    <tr>
                      <td>Outlinks count</td>
                      <td> {{ page.outlinks_count }} </td>
                    </tr>
                    <tr>
                      <td>x robots tag</td>
                      <td> {{ page.x_robots_tag }} </td>
                    </tr>
                  </tbody>
                </table>
              </v-card>
            </v-tab-item>
            <v-tab-item key="words">
              <v-card flat>
                <table v-if="page" class="tabs-table v-datatable v-table v-datatable--select-all theme--light">
                  <thead>
                    <tr>
                      <th class="text-xs-left">Word</th>
                      <th class="text-xs-left">Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="word in page.top_10_words" :key="word[0]">
                      <td>"{{ word[0] }}"</td>
                      <td> {{ word[1] }} </td>
                    </tr>
                  </tbody>
                </table>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'LinkDetailModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['linkDetailDialog', 'linkData', 'loading'],
  data () {
    return {
      moment: this.$moment,
      page: null,
      dialog: false,
      log: '',
      activeTab: 0,
      headers: [
        { text: 'Property', value: 'Property', sortable: false },
        { text: 'Data', value: 'Data', sortable: false }
      ],
      dictionary: {
        en: {
          custom: {
            'link_detail.link': {
              required: 'Link required'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    linkDetailDialog: {
      handler () {
        console.log('asd')
        if (this.linkDetailDialog && this.linkData.id) {
          this.getLink()
        }
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('linkDetailDialog', this.dialog)
      }
    }
  },
  methods: {
    getLink () {
      this.$parent.$emit('loading', true)
      this.$store.dispatch('GET_LINK', this.linkData.id).then(res => {
        this.page = res
        this.$parent.$emit('loading', false)
        this.activeTab = 0
        this.dialog = this.linkDetailDialog
      }, err => {
        console.log('login error', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('LINK_LOG ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/link-detail-modal/LinkDetailModal.vue